export default "__VITE_ASSET__Dff0OgNu__"